import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    class: "df-custom__symbol",
    "aria-hidden": "true"
};
import { computed } from "vue";
import { useDonation } from "../../context/donationContext";
import { useChrome } from "../../i18n/useChrome";
import { currencySymbol } from "../../composables/useCurrency";
import BaseField from "../ui/BaseField.vue";
import BaseInput from "../ui/BaseInput.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CustomAmountInput',
    props: {
        error: { default: "" }
    },
    setup(__props) {
        // SYNC: see ../../_SYNC.md.
        const { custom, setCustom, currency, lang, minimumAmountMinor, formatMinor } = useDonation();
        const { tf } = useChrome();
        const symbol = computed(() => currencySymbol(currency.value, lang.value));
        const hint = computed(() => minimumAmountMinor.value === null
            ? tf("amount.customHint")
            : tf("amount.customHintMinimum", { min: formatMinor(minimumAmountMinor.value) }));
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(BaseField, {
                label: _unref(tf)('amount.customLabel'),
                hint: hint.value,
                error: __props.error
            }, {
                default: _withCtx(({ fieldId, describedBy, hasError }) => [
                    _createElementVNode("div", {
                        class: "df-custom",
                        style: _normalizeStyle({ '--df-amount-prefix-chars': symbol.value.length })
                    }, [
                        _createElementVNode("span", _hoisted_1, _toDisplayString(symbol.value), 1 /* TEXT */),
                        _createVNode(BaseInput, {
                            id: fieldId,
                            variant: "amount",
                            inputmode: "numeric",
                            placeholder: _unref(tf)('amount.customPlaceholder'),
                            "model-value": _unref(custom),
                            "aria-describedby": describedBy,
                            invalid: hasError,
                            "onUpdate:modelValue": _unref(setCustom)
                        }, null, 8 /* PROPS */, ["id", "placeholder", "model-value", "aria-describedby", "invalid", "onUpdate:modelValue"])
                    ], 4 /* STYLE */)
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["label", "hint", "error"]));
        };
    }
});
